import { createContext, useContext } from 'react';

export const NotesContext = createContext();

const useNotesContext = () => useContext(NotesContext);

export default useNotesContext;
